import { ReactNode, useLayoutEffect } from 'react';
import { useAppSelector } from '../store';
import { selectTheme } from '../store/theme';
import { generatePalette } from 'utils/generatePalette';

export const ThemeWrapper = ({ children }: { children: ReactNode }) => {
  const { color, mode, theme } = useAppSelector(selectTheme);

  useLayoutEffect(() => {
    const palette = generatePalette(
      color,
      mode as 'light' | 'dark',
      theme as 'theme-1' | 'theme-2' | 'theme-3',
    );
    if (palette) {
      Object.entries(palette).forEach(([key, value]) => {
        document.documentElement.style.setProperty(key, value as string);
      });
    }
  }, [color, mode, theme]);

  return <div className={`${theme} ${mode} ${theme}--${mode} _text-color`}>{children}</div>;
};
